import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehavioralAssessmentsInformation } from '../../models/behavioral-assessments-information.model';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TestsService {
  constructor(private httpClient: HttpClient) {}

  public getBehavioralAssessments(): Observable<BehavioralAssessmentsInformation> {
    return this.httpClient.get<BehavioralAssessmentsInformation>(
      `${environment.applicantApiEndpoint}/behavioral-assessments/information`,
    );
  }

  public getBehavioralAssessmentsForJobOpportunity(
    jobOpportunityId: string,
  ): Observable<BehavioralAssessmentsInformation | null> {
    return this.httpClient
      .get<BehavioralAssessmentsInformation>(
        `${environment.applicantApiEndpoint}/behavioral-assessments/information/for/job-opportunity/${jobOpportunityId}`,
      )
      .pipe(
        catchError((e) => {
          if (e instanceof HttpErrorResponse && e.status === 404) {
            return of(null);
          }
          return throwError(() => e);
        }),
      );
  }
}
